module.exports = {"title":"Station","outlet_details":"Station Details","create_outlet":"Create New Station","pricebook":"Main Pricebook","central_devices":"Devices"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/outlet.php
// module id = I0Im
// module chunks = 50